/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { io } from "socket.io-client";
import { setMessageData, setOpenMessageModal } from "./messageModal";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../pages/ApiFunction/axiosInstance";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const initializeSocket = (token, dispatch, userData) => {
  try {
    const newSocket = io(axiosInstance.defaults.baseURL.replace('api/', ''), {
      auth: { token: token },
      reconnectionAttempts: 15,
      transports: ["websocket", "polling"], // Added polling as fallback
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      timeout: 20000,
    });

    newSocket.on("connect", (res) => {
      // console.log("Connected to socket server", console.log('res :>> ', res));
      newSocket.emit("authenticate", token);
    });

    newSocket.on("authenticated", (id) => {
      console.log("Socket authenticated", id);
    });

    newSocket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    newSocket.on("unauthorized", (error) => {
      console.error("Unauthorized socket connection:", error.message);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log(attemptNumber, "reconnect");
      newSocket.emit("authenticate", token);
    });

    newSocket.on("disconnect", (reason) => {
      console.warn("Socket disconnected:", reason);
    });

    newSocket.on("send-message", (data) => {
      if (userData?._id !== data?.sender?._id) {
        dispatch(
          setMessageData({
            title: "New Message Received",
            message: `${data?.sender?.name} sent you a message: ${data?.message} from @${data?.sender?.name}`,
            type: "message",
            user: data?.sender,
            to_id: data?.sender,
            sender: data?.sender,
          }),
        );
        dispatch(setOpenMessageModal(true));
      }
    });

    newSocket.on("admin-noti", (data) => {
      dispatch(
        setMessageData({
          ...data,
        }),
      );
      dispatch(setOpenMessageModal(true));

      // Keep Commercial Builder sidebar badges in sync when new companies / apps arrive
      const service = String(data?.service || data?.metadata?.service || "").toLowerCase();
      const title = String(data?.title || "").toLowerCase();
      const message = String(data?.message || "").toLowerCase();
      const kind = String(data?.metadata?.kind || data?.kind || "").toLowerCase();
      const isCompanyNoti =
        service === "company" ||
        title.includes("company") ||
        message.includes("company application");
      const isLeadNoti =
        service === "lead" ||
        title.includes("lead") ||
        message.includes("demo request");
      const isOfferNoti =
        kind === "builder_offer" ||
        service === "offer" ||
        title.includes("builder offer") ||
        title.includes("commercial offer") ||
        message.includes("builder offer") ||
        message.includes("commercial offer");

      if (isCompanyNoti && typeof window !== "undefined") {
        window.dispatchEvent(new Event("refreshCompanyCounts"));
      }
      if (isLeadNoti && typeof window !== "undefined") {
        window.dispatchEvent(new Event("refreshLeadCounts"));
      }
      if (isOfferNoti && typeof window !== "undefined") {
        window.dispatchEvent(new Event("refreshBuilderOfferCounts"));
      }
    });

    return newSocket;
  } catch (error) {
    console.error("Error initializing socket:", error);
    return null;
  }
};

export const SocketProvider = ({ children }) => {
  const token = useSelector((state) => state.user?.token);
  const userData = JSON.parse(localStorage.getItem("admin_data"));
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    console.log("Initializing socket...");
    const newSocket = initializeSocket(token, dispatch, userData);
    setSocket(newSocket);
    socketRef.current = newSocket;

    return () => {
      if (socketRef.current) {
        console.log("Disconnecting socket...");
        socketRef.current.disconnect();
        socketRef.current = null;
        setSocket(null);
      }
    };
  }, [token]);
 
 return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const connectSocket = (token, dispatch, userData) =>
  initializeSocket(token, dispatch, userData);
